module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Norm-Center",
    attrs: {
      "id": "auto_bookmark_toc_3"
    }
  }, [_c('span', [_vm._v("This book is dedicated to my husband, Andrew. I asked him to suggest a really big plot for book three. This is the result. Blame him, okay?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-Center"
  }, [_c('span', [_vm._v("But seriously… I couldn’t have written this without him.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79013302","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0